import logger from "../util/logger";
import { ReduxDispatch, ReduxGetState, ReduxState } from "./reducers";
import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "../util/redux/typed-reducers";
import { env } from "../util/env";
import * as request from "../util/request";

const actionFactory = actionCreatorFactory("Hypo/Tupas");

export const loadTupasProviders = actionFactory<
    ITupasLoadProperties,
    IProvidersResponse,
    string
>("LOAD_TUPAS_PROVIDERS");
export const loadTupasAction = actionFactory<
    string,
    ITupasActionResponse,
    string
>("LOAD_TUPAS_ACTION");

export interface IProvidersResponse {
    providers: IProvidersItem[];
    languageCode: string;
    stamp: string;
}
export interface IProvidersItem {
    name: string;
    id: string;
    url: string;
    imageUrl: string;
    request: IRequest;
    response: IResponse;
}
export interface IRequest {
    actionId: string;
    version: string;
    provider: string;
    idType: string;
    returnUrl: string;
    cancellationUrl: string;
    rejectionUrl: string;
    keyVersion: string;
    algorithm: string;
    providerKey: string;
    mac: string;
}
interface IResponse {
    version: string | null;
    timestamp: string | null;
    identifier: string | null;
    stamp: string | null;
    customerName: string | null;
    keyVersion: string | null;
    algorithm: string | null;
    customerId: string | null;
    customerType: string | null;
    userId: string | null;
    userName: string | null;
    mac: string | null;
    providerKey: string | null;
    providerId: string | null;
}

export interface ITupasLoadProperties {
    tupasRedirectPath?: string;
    tupasErrorReturnPath?: string;
}

export interface ITupasActionResponse {
    hash: string;
    action: number;
    customerName: string | undefined;
    customerId: string | undefined;
}

export function startLoadingTupasProviders(
    loadProps: ITupasLoadProperties,
    requestType?: number
) {
    return async (dispatch: ReduxDispatch) => {
        try {
            dispatch(loadTupasProviders(loadProps));
            const providerInfo = await request.post<IProvidersResponse>(
                `${env.APP_API_HOST}/api/tupas/${
                    (requestType && requestType) || "1"
                }`,
                {}
            );
            dispatch(loadTupasProviders.done(providerInfo));
        } catch (error) {
            dispatch(loadTupasProviders.failed("Failed to load provider data"));
        }
    };
}

export function fetchTupasAction(tupasQueryString: string) {
    return async (dispatch: ReduxDispatch) => {
        try {
            dispatch(loadTupasAction(tupasQueryString));
            const response = await request.post<ITupasActionResponse>(
                `${env.APP_API_HOST}/api/tupas/success${tupasQueryString}`,
                {}
            );
            dispatch(loadTupasAction.done(response));
        } catch (error) {
            dispatch(loadTupasAction.failed("Loading tupas action failed."));
        }
    };
}

export class TupasState {
    providerInfo?: IProvidersResponse;
    loading = false;
    tupasAction: number;
    //tupasRedirectPath?: string;
    //tupasErrorReturnPath?: string;
    error?: string;
    tupasActionResponse?: ITupasActionResponse;
}

const initialTupasState: TupasState = {
    providerInfo: undefined,
    loading: false,
    tupasAction: 1,
    //tupasRedirectPath: sessionStorage.getItem("redirectPath") || undefined,
    error: undefined,
    tupasActionResponse: undefined,
    //tupasErrorReturnPath: sessionStorage.getItem("errorReturnPath") || undefined,
};

export const TupasReducer = reducerWithInitialState(initialTupasState)
    .case(loadTupasProviders, (state, action) => {
        // NOTE: TUPAS will do a roundtrip on providers portal so state will be reloaded.
        // That's why we want the redirect url to be saved on session also so that we can redirect
        // back to previous content after tupas is done.
        sessionStorage.setItem(
            "redirectPath",
            action.payload.tupasRedirectPath || "/"
        );
        sessionStorage.setItem(
            "errorReturnPath",
            action.payload.tupasErrorReturnPath || "/"
        );
        return {
            ...state,
            tupasRedirectPath: action.payload.tupasRedirectPath,
            tupasErrorReturnPath: action.payload.tupasErrorReturnPath,
            loading: true,
            tupasActionResponse: undefined,
        };
    })
    .case(loadTupasProviders.done, (state, action) => {
        return {
            ...state,
            providerInfo: action.payload,
            loading: false,
            error: undefined,
        };
    })
    .case(loadTupasProviders.failed, (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    })
    .case(loadTupasAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(loadTupasAction.done, (state, action) => {
        return {
            ...state,
            loading: false,
            tupasActionResponse: action.payload,
        };
    })
    .case(loadTupasAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    });

export function getProviders(state: ReduxState): IProvidersResponse | null {
    return (state.tupas && state.tupas.providerInfo) || null;
}

export function getTupasActionResponse(
    state: ReduxState
): ITupasActionResponse | undefined {
    return state.tupas && state.tupas.tupasActionResponse;
}
// export function getRedirectPath(state: ReduxState): string | undefined {
//     return state.tupas.tupasRedirectPath;
// }

// export function getErrorReturnPath(state: ReduxState): string | undefined {
//     return state.tupas.tupasErrorReturnPath;
// }

export default TupasReducer;



// WEBPACK FOOTER //
// ./src/ducks/tupas.ts